<template>
  <div class="list-container">
    <entity-filter v-show="!showAdvancedFilter" :data-list="users" :title="title"
    :searchable-fields="searchableFields" show-alphabetized-filter="false" 
    :use-group="true" :group-by-options="groupByOptions" :actions="actions" >
    </entity-filter>

    <generic-table v-show="!showAdvancedFilter" :title-map="titleMap" 
    :table-body="users" :end-point="endPoint"></generic-table>
  </div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import AdvancedFilter from '../AdvancedFilter';
import EntityFilter from '../EntityFilter';
import GenericTable from '../GenericTable';
import store from '../../store.js';
import { bus } from '../../main';
import advancedSearchResults from '../advancedSearchResult';
import CreateButton from '../CreateButton';
import ActionList from '../ActionList';

export default {
  data() {
    return {
      title: {'icon': 'icon-customers', 'name': "Users"},
      titleMap: {
        'first_name': 'First Name',
        'last_name': 'Last Name',
        'is_manager': 'Manager',
        'email': 'Email'
      },
      groupByOptions: {
        'status': 'Status',
        'first_name': 'First Name',
        'last_name': 'Last Name',
      },
      endPoint: 'users/{{ id }}/details',
      searchableFields: ['first_name', 'last_name'],
      label: 'Loading',
      actions: [
        {
          name: 'Reset User Password', 
          url: "/users/reset-for-user",
          perm: "view_user"
        }, 
        { 
          name: 'Invite New User', 
          url: "/users/invite-user",
          perm: "invite_user"
        }
      ]
    };
  },
  
  methods: {
    toggleSidebar(){
      bus.$emit('toggle-sidebar');
    },
  },
  
  mounted() {
    this.toggleSidebar();
  },
  
  computed:{
    ...mapState({
      showAdvancedFilter: state => state.showAdvancedFilter,
      loading: state => state.loading,
      users: function(state) {
        let users = [];
        if (store.state.users !== null) {
          users = store.state.users;
        }
        return users;
      },
    }),

  },
  beforeRouteEnter (to, from, next) {
    store.dispatch('fetchUsers');
    next();
  },
  components:{
    GenericTable,
    EntityFilter,
    AdvancedFilter,
    advancedSearchResults,
    CreateButton,
    ActionList
  }
};
</script>
<style lang="scss" scoped>
  .create-button-container{
    height:75px;
    width: 140%;
    background-color:white;
    margin-left: -1.5rem;
    padding-left: 26px;
    border-top: 1px solid #cfcfcf;
  }
  h1{
    height: 21px;
  }
  .list-container{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/UserList.vue